/**
 * Enum for date range preset values
 */
export enum DateRangePreset {
  TODAY = "today",
  YESTERDAY = "yesterday",
  THIS_WEEK_TO_DATE = "thisWeekToDate",
  LAST_7_DAYS = "last7Days",
  LAST_WEEK = "lastWeek",
  LAST_MONTH = "lastMonth",
  LAST_QUARTER = "lastQuarter",
  LAST_6_MONTHS = "last6Months",
  THIS_YEAR_TO_DATE = "thisYearToDate",
  LAST_YEAR = "lastYear",
  CUSTOM = "custom"
}

/**
 * Enum for report error keys
 */
export enum ReportErrorKey {
  NO_TRANSACTIONS_FOUND = "no_transactions_found",
  INVALID_DATE_FORMAT = "invalid_date_format",
  GENERAL_ERROR = "general_error"
}

/**
 * Map of error keys to translation keys
 */
export const REPORT_ERROR_MESSAGES: Record<ReportErrorKey, string> = {
  [ReportErrorKey.NO_TRANSACTIONS_FOUND]: "generateReport.noTransactionsFound",
  [ReportErrorKey.INVALID_DATE_FORMAT]: "generateReport.error.invalidDateSelection",
  [ReportErrorKey.GENERAL_ERROR]: "generateReport.generateReportError"
};

/**
 * Form values for the generate report form
 */
export interface GenerateReportFormValues {
  reportType: string;
  locationIds: string[];
  emailTo: string[];
  dateRangePreset: DateRangePreset;
  startDate?: Date;
  endDate?: Date;
}